<!-- Featured Event Hero Banner -->
<div class="hero-banner" *ngIf="featuredEvents.length > 0">
  <div class="hero-image">
    <img
      [src]="getFeaturedImageUrl()"
      [alt]="featuredEvents[currentFeaturedIndex]?.name"
    />
    <div class="hero-overlay"></div>
  </div>
  <div class="hero-content">
    <span class="hero-badge">Featured Event</span>
    <h2 class="hero-title">{{ featuredEvents[currentFeaturedIndex]?.name }}</h2>
    <div class="hero-meta">
      <span class="hero-meta-item">
        <i nz-icon nzType="calendar" aria-hidden="true"></i>
        {{ featuredEvents[currentFeaturedIndex]?.date | date: 'mediumDate' }}
      </span>
      <span
        class="hero-meta-item"
        *ngIf="featuredEvents[currentFeaturedIndex]?.location?.description"
      >
        <i nz-icon nzType="environment" aria-hidden="true"></i>
        {{ featuredEvents[currentFeaturedIndex]?.location?.description }}
      </span>
    </div>
  </div>
  <div class="hero-dots" *ngIf="featuredEvents.length > 1">
    <button
      *ngFor="let event of featuredEvents; let i = index"
      type="button"
      class="hero-dot"
      [class.active]="i === currentFeaturedIndex"
      (click)="goToFeatured(i)"
      [attr.aria-label]="'Go to event ' + (i + 1)"
    ></button>
  </div>
</div>

<div class="page-container">
  <div class="page-header">
    <h1>Events</h1>
    <p>Browse upcoming events and save your favourites</p>
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <button
      type="button"
      class="tab"
      [class.active]="activeTab === 'active'"
      (click)="switchTab('active')"
    >
      Upcoming Events
    </button>
    <button
      type="button"
      class="tab"
      [class.active]="activeTab === 'coming-soon'"
      (click)="switchTab('coming-soon')"
    >
      Coming Soon
    </button>
  </div>

  <nz-spin [nzSpinning]="loading">
    <!-- Active Events -->
    <div *ngIf="activeTab === 'active'">
      <ng-container *ngIf="activeEvents.length > 0 || loading; else noActive">
        <hypenation-tickets-events-list
          [events]="activeEvents"
          [totalItems]="activeTotalItems"
          [loading]="loading"
          loadMode="button"
          [hasMore]="activeHasMore"
          [loadingMore]="activeLoadingMore"
          (loadMore)="loadMoreActive()"
        >
          <ng-template #cardTemplate let-event>
            <a
              class="event-card"
              [routerLink]="[
                '/tickets',
                event.slug,
                event.uid,
                event.eventType?.uid
              ]"
            >
              <div class="event-image">
                <img
                  [src]="getImageUrl(event)"
                  [alt]="event.name"
                  width="400"
                  height="220"
                  loading="lazy"
                />
                <span class="price-badge">{{
                  formatPrice(event.minPrice, event.maxPrice)
                }}</span>
                <button
                  type="button"
                  class="wishlist-btn"
                  [class.active]="isInWishlist(event.uid)"
                  [disabled]="isWishlistLoading(event.uid)"
                  (click)="toggleWishlist(event, $event)"
                  [attr.aria-label]="
                    isInWishlist(event.uid)
                      ? 'Remove from wishlist'
                      : 'Add to wishlist'
                  "
                >
                  <i
                    nz-icon
                    nzType="heart"
                    nzTheme="fill"
                    *ngIf="isInWishlist(event.uid)"
                    aria-hidden="true"
                  ></i>
                  <i
                    nz-icon
                    nzType="heart"
                    nzTheme="outline"
                    *ngIf="!isInWishlist(event.uid)"
                    aria-hidden="true"
                  ></i>
                </button>
                <span class="coming-soon-badge" *ngIf="!event.published"
                  >Coming Soon</span
                >
              </div>

              <div class="event-info">
                <h3 class="event-name">{{ event.name }}</h3>
                <div class="event-meta">
                  <div class="meta-item">
                    <i nz-icon nzType="calendar" aria-hidden="true"></i>
                    <span
                      >{{ event.date | date: 'mediumDate' }} &middot;
                      {{ formatEventTime(event.time) }}</span
                    >
                  </div>
                  <div class="meta-item" *ngIf="event.location?.description">
                    <i nz-icon nzType="environment" aria-hidden="true"></i>
                    <span>{{ event.location.description }}</span>
                  </div>
                </div>
              </div>
            </a>
          </ng-template>
        </hypenation-tickets-events-list>
      </ng-container>

      <ng-template #noActive>
        <div class="empty-state">
          <div class="empty-icon">
            <i nz-icon nzType="calendar" aria-hidden="true"></i>
          </div>
          <h3 class="empty-title">No Upcoming Events</h3>
          <p class="empty-desc">Check back soon for new events.</p>
        </div>
      </ng-template>
    </div>

    <!-- Coming Soon Events -->
    <div *ngIf="activeTab === 'coming-soon'">
      <ng-container *ngIf="comingSoonEvents.length > 0 || loading; else noComingSoon">
        <hypenation-tickets-events-list
          [events]="comingSoonEvents"
          [totalItems]="comingSoonTotalItems"
          [loading]="loading"
          loadMode="button"
          [hasMore]="comingSoonHasMore"
          [loadingMore]="comingSoonLoadingMore"
          (loadMore)="loadMoreComingSoon()"
        >
          <ng-template #cardTemplate let-event>
            <div class="event-card coming-soon">
              <div class="event-image">
                <img
                  [src]="getImageUrl(event)"
                  [alt]="event.name"
                  width="400"
                  height="220"
                  loading="lazy"
                />
                <span class="coming-soon-badge">Coming Soon</span>
                <button
                  type="button"
                  class="wishlist-btn"
                  [class.active]="isInWishlist(event.uid)"
                  [disabled]="isWishlistLoading(event.uid)"
                  (click)="toggleWishlist(event, $event)"
                  [attr.aria-label]="
                    isInWishlist(event.uid)
                      ? 'Remove from wishlist'
                      : 'Add to wishlist'
                  "
                >
                  <i
                    nz-icon
                    nzType="heart"
                    nzTheme="fill"
                    *ngIf="isInWishlist(event.uid)"
                    aria-hidden="true"
                  ></i>
                  <i
                    nz-icon
                    nzType="heart"
                    nzTheme="outline"
                    *ngIf="!isInWishlist(event.uid)"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>

              <div class="event-info">
                <h3 class="event-name">{{ event.name }}</h3>
                <div class="event-meta">
                  <div class="meta-item">
                    <i nz-icon nzType="calendar" aria-hidden="true"></i>
                    <span
                      >{{ event.date | date: 'mediumDate' }} &middot;
                      {{ formatEventTime(event.time) }}</span
                    >
                  </div>
                  <div class="meta-item" *ngIf="event.location?.description">
                    <i nz-icon nzType="environment" aria-hidden="true"></i>
                    <span>{{ event.location.description }}</span>
                  </div>
                </div>
                <p class="coming-soon-note">
                  Tickets not yet available. Add to your wishlist to be notified.
                </p>
              </div>
            </div>
          </ng-template>
        </hypenation-tickets-events-list>
      </ng-container>

      <ng-template #noComingSoon>
        <div class="empty-state">
          <div class="empty-icon">
            <i nz-icon nzType="clock-circle" aria-hidden="true"></i>
          </div>
          <h3 class="empty-title">Nothing Coming Soon</h3>
          <p class="empty-desc">
            No upcoming announcements yet. Check back later.
          </p>
        </div>
      </ng-template>
    </div>
  </nz-spin>
</div>

<!-- Ticket Type Selection Modal -->
<nz-modal
  [(nzVisible)]="ticketTypeModalVisible"
  [nzTitle]="'Select Ticket Type'"
  [nzOkText]="'Add to Wishlist'"
  [nzOkDisabled]="!selectedTicketTypeUid"
  (nzOnOk)="confirmAddToWishlist()"
  (nzOnCancel)="cancelTicketTypeModal()"
  [nzWidth]="480"
>
  <ng-container *nzModalContent>
    <div *ngIf="ticketTypeModalEvent" class="modal-event-header">
      <h3 class="modal-event-name">{{ ticketTypeModalEvent.name }}</h3>
      <p class="modal-event-date">{{ ticketTypeModalEvent.date | date: 'mediumDate' }}</p>
    </div>

    <nz-spin [nzSpinning]="ticketTypesLoading">
      <div
        *ngIf="ticketTypes.length > 0; else noTypes"
        class="custom-ticket-list"
      >
        <div
          *ngFor="let type of ticketTypes"
          class="custom-ticket-option"
          [class.selected]="selectedTicketTypeUid === type.uid"
          [class.disabled]="type.status === 'CLOSED'"
          (click)="
            type.status !== 'CLOSED' && (selectedTicketTypeUid = type.uid)
          "
        >
          <div class="custom-radio">
            <div
              class="radio-inner"
              *ngIf="selectedTicketTypeUid === type.uid"
            ></div>
          </div>
          <div class="ticket-content">
            <div class="ticket-info">
              <span class="ticket-name">{{ type.name }}</span>
              <span class="ticket-desc" *ngIf="type.description">{{
                type.description
              }}</span>
            </div>
            <div class="ticket-price-section">
              <span class="ticket-price">{{ formatTicketPrice(type) }}</span>
              <span class="ticket-closed" *ngIf="type.status === 'CLOSED'"
                >Closed</span
              >
            </div>
          </div>
        </div>
      </div>
      <ng-template #noTypes>
        <p class="no-types-text">No ticket types available for this event.</p>
      </ng-template>
    </nz-spin>
  </ng-container>
</nz-modal>
